import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { ContractTypeActions } from './contract-type.actions';
import { ContractType } from '../../models/contract-type.model';
import { AlertService } from '../alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { ContractTypeService } from '../../services/contract-type.service';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class ContractTypeStateModel {
  public contractTypes: ContractType[];
  public error: string;
}

const defaults = {
  contractTypes: [],
  error: '',
};

@State<ContractTypeStateModel>({
  name: 'contractType',
  defaults
})
@Injectable()
export class ContractTypeState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private contractTypeService: ContractTypeService
  ) { }

  @Action(ContractTypeActions.GetContractTypes)
  getContractTypes(ctx: StateContext<ContractTypeStateModel>, {  }: ContractTypeActions.GetContractTypes) {
    return this.contractTypeService.getContractTypes().subscribe({
      next: (contractTypes: ContractType[]) => {
        ctx.dispatch(new ContractTypeActions.GetContractTypesSuccess(contractTypes));
      },
      error: (error) => {
        ctx.dispatch(new ContractTypeActions.GetContractTypesFail(error));
      }
    });
  }

  @Action(ContractTypeActions.GetContractTypesSuccess)
    getContractTypesSuccess(ctx: StateContext<ContractTypeStateModel>,
      { contractTypes }: ContractTypeActions.GetContractTypesSuccess
    ) {
      ctx.patchState({
        contractTypes: contractTypes
      });
    }

    @Action(ContractTypeActions.GetContractTypesFail)
    GetContractTypesFailed(
      ctx: StateContext<ContractTypeStateModel>,
      { error }: ContractTypeActions.GetContractTypesFail
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('contract-types.title');
    }
}
